import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { gsap, Elastic } from "gsap/all";
import useDisableBrowserBack from "../hooks/useDisableBrowserBack";

function Outro({screen}){
  useDisableBrowserBack();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [step, setStep] = useState(screen? screen : 0);
  const [initState, setInitState] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#2b2b2b');
    setIsSubmitting(false);
  }, []);

  const handleContinueButton = (e) => {
    e.preventDefault();
    if(step === 0){
      setIsSubmitting(true);
      setStep(1);
      navigate("/app/game/outro/2" + window.location.search);
    }
    else if (step === 1) {
      setIsSubmitting(true);
      setTimeout(()=>{
        navigate("/app/game/overview" + window.location.search);
      }, 500); 
    }
  }

  const handleBackButton = (e) => {
    e.preventDefault();
    if (step === 1) {
      navigate("/app/game/outro/1" + window.location.search);
      setStep(0);
      setInitState(false);
    }
  }

  return(
    <div className={`mobileContainer backgroundGold intro-screen`}>
      <div className="content-wrapper">
        <div className={`content-1 frameExpressive 
          ${step === 0 ? '_anim-in' : ''}
          ${step != 0 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.ready.content_1_1')}</p>
        </div>
        <div className={`content-2 speechBalloonSmall 
          ${step === 0 ? '_anim-in' : ''}
          ${step != 0 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.ready.content_1_2')}</p>
        </div>
      </div>
      <div className="content-wrapper">
        <div className={`content-3 frameExpressive 
          ${step === 1 ? '_anim-in' : ''}
          ${step != 1 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.ready.content_2_1')}</p>
        </div>
        <div className={`content-4 speechBalloonSmall 
          ${step === 1 ? '_anim-in' : ''}
          ${step != 1 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.ready.content_2_2')}</p>
        </div>
      </div>
      <div className={`navigationDrawer spread variant6 enableInAnimation`}>
        <a className="chromelessIconButton" onClick={handleBackButton}>
          {step === 1 && (
            <span className="icon icon-backward-simple"></span>
          )}
        </a>
        <a className="chromelessIconButton" onClick={handleContinueButton}>
          <span className="caption">{t('student.game.continue_label')}</span>
          <span className="icon icon-forward"></span>
        </a>
      </div>
    </div>
  );
}

export default Outro;